export enum TransactionsTab {
  pending = 'PENDING',
  executed = 'EXECUTED',
  closed = 'CLOSED',
}
